import { render, staticRenderFns } from "./EditRevisionPage.vue?vue&type=template&id=18fcf906"
import script from "./EditRevisionPage.vue?vue&type=script&lang=js"
export * from "./EditRevisionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports